module.exports = __webpack_public_path__ + "static/media/new_logo.c16154b9.svg";